import getWindow from "./getWindow.js";
export default function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/dom-utils/getComputedStyle.js
// module id = 55
// module chunks = 1